import { writable } from 'svelte/store';
export const notification = writable(undefined);
let delayedAction = undefined;
export const notify = (newMessage) => {
    clearTimeout(delayedAction);
    notification.set(newMessage);
    delayedAction = setTimeout(clearNotif, 5000);
};
export const notifySuccess = (text) => notify({
    text,
    type: 'is-success'
});
export const notifyError = (text) => notify({
    text,
    type: 'is-danger'
});
export const clearNotif = () => notify(undefined);
